import {
  ArrowCounterClockwiseIcon,
  ClipboardTextIcon,
  ClockCounterClockwiseIcon,
  CopyIcon,
  FileArrowDownIcon,
  FloppyDiskBackIcon,
  PencilSimpleIcon,
  PlusIcon,
  TrashIcon,
  TShirtIcon,
  UsersThreeIcon,
} from '@phosphor-icons/react'

import { actionSectionIds, sectionIds, sections, viewStatuses } from './constants'

export const getActions = ({
  t,
  selectedView,
  hasViewChanges,
  onDuplicateView,
  onDeleteView,
  onSaveChanges,
  onCreateView,
  onEditViewName,
  onManageVisibility,
  onDiscardChanges,
  onExportResults,
  onlyDefaultViews,
  onImportInventoryData,
  onImportProductValidation,
  onImportCreateRmas,
  onPageHistory,
  canEditViews = true,
  canManageSelectedView = true,
}) => {
  const actions = [
    {
      label: t('Guardar cambios'),
      Icon: FloppyDiskBackIcon,
      onClick: () => onSaveChanges(),
      visibleWhen: [viewStatuses.changes],
      hideForDefaultView: true,
      requiresViewManagement: true,
      requiresEditPermission: true,
      section: actionSectionIds.views,
    },
    {
      label: t('Guardar como nueva vista'),
      Icon: PlusIcon,
      onClick: onCreateView,
      visibleWhen: [viewStatuses.changes],
      hideForDefaultView: onlyDefaultViews,
      requiresEditPermission: true,
      section: actionSectionIds.views,
    },
    {
      label: t('Renombrar vista'),
      Icon: PencilSimpleIcon,
      onClick: onEditViewName,
      visibleWhen: [viewStatuses.default],
      hideForDefaultView: true,
      requiresViewManagement: true,
      requiresEditPermission: true,
      section: actionSectionIds.views,
    },
    {
      label: t('Gestionar visibilidad'),
      Icon: UsersThreeIcon,
      onClick: onManageVisibility,
      visibleWhen: [viewStatuses.default],
      hideForDefaultView: true,
      requiresViewManagement: true,
      requiresEditPermission: true,
      section: actionSectionIds.views,
    },
    {
      label: t('Duplicar vista'),
      Icon: CopyIcon,
      onClick: onDuplicateView,
      visibleWhen: [viewStatuses.default],
      hideForDefaultView: onlyDefaultViews,
      requiresEditPermission: true,
      section: actionSectionIds.views,
    },
    {
      label: t('Eliminar vista'),
      Icon: TrashIcon,
      onClick: onDeleteView,
      visibleWhen: [viewStatuses.default],
      hideForDefaultView: true,
      requiresViewManagement: true,
      requiresEditPermission: true,
      section: actionSectionIds.views,
    },
    {
      label: t('Descartar cambios'),
      Icon: ArrowCounterClockwiseIcon,
      onClick: onDiscardChanges,
      visibleWhen: [viewStatuses.changes],
      hideForDefaultView: onlyDefaultViews,
      requiresEditPermission: true,
      section: actionSectionIds.views,
    },
    {
      label: t('Exportar listado'),
      Icon: FileArrowDownIcon,
      onClick: onExportResults,
      visibleWhen: [viewStatuses.default, viewStatuses.changes],
      hideForDefaultView: false,
      section: actionSectionIds.importExport,
    },
    {
      label: t('Historial de la página'),
      Icon: ClockCounterClockwiseIcon,
      onClick: onPageHistory,
      visibleWhen: [viewStatuses.default, viewStatuses.changes],
      hideForDefaultView: false,
      section: actionSectionIds.importExport,
    },
    {
      label: t('Exportar / importar inventario'),
      Icon: ClipboardTextIcon,
      onClick: onImportInventoryData,
      visibleWhen: [viewStatuses.default, viewStatuses.changes],
      hideForDefaultView: false,
      section: actionSectionIds.importExport,
    },
    {
      label: t('Validar productos'),
      Icon: TShirtIcon,
      onClick: onImportProductValidation,
      visibleWhen: [viewStatuses.default, viewStatuses.changes],
      hideForDefaultView: false,
      section: actionSectionIds.importExport,
    },
    {
      label: t('Crear RMAs'),
      Icon: PlusIcon,
      onClick: onImportCreateRmas,
      visibleWhen: [viewStatuses.default, viewStatuses.changes],
      hideForDefaultView: false,
      section: actionSectionIds.importExport,
    },
  ]

  const currentStatus = hasViewChanges ? viewStatuses.changes : viewStatuses.default

  return actions.filter(action => {
    const hasHandler = Boolean(action.onClick)
    const isVisibleForStatus = action.visibleWhen.includes(currentStatus)
    const isVisibleForView = selectedView?.isDefaultView ? !action.hideForDefaultView : true
    const isAllowedByPermission = canEditViews || !action.requiresEditPermission
    const isAllowedByOwnership = canManageSelectedView || !action.requiresViewManagement

    return hasHandler && isVisibleForStatus && isVisibleForView && isAllowedByPermission && isAllowedByOwnership
  })
}

export const isPrivateView = view => view.shared_with_groups?.length === 0

const getCustomViewSection = view => (isPrivateView(view) ? sectionIds.privateViews : sectionIds.sharedViews)

export const joinCustomViewsAndDefaultViews = (customViews = [], defaultViews = []) => {
  return [
    ...defaultViews,
    ...customViews.map(view => ({
      ...view,
      section: getCustomViewSection(view),
      isDefaultView: false,
    })),
  ]
}

export const getSections = views => {
  return sections.filter(section => views.some(view => view.section === section.id))
}
